<template>
  <div>
    <div class="mb-4">
      <send-attendance-survey :disabled="disabled" survey-type="ptiga"></send-attendance-survey>
    </div>
    <div>Considerando as opções abaixo, como você descreveria a sua dermatite atópica?</div>
    <div>Escolha apenas uma opção!</div>
    <v-radio-group :disabled="disabled" v-model="form.ptiga.value" hide-details="auto" color="primary" class="mb-4">
      <v-radio
        v-for="option in ptigaOptions"
        color="primary"
        :key="option.text"
        :label="option.text"
        :value="option.value"
      />
    </v-radio-group>
    <v-row>
      <v-col cols="12">
        <span class="reference">
          Referência: Traduzido pela Dra Ana Paula Galli, baseado no cálculo Investigator Global Assessment. <br />
          Bożek, Agnieszka, and Adam Reich. "Assessment of intra-and inter-rater reliability of three methods for
          measuring atopic dermatitis severity: EASI, objective SCORAD, and IGA." Dermatology 233.1 (2017): 16-22.
        </span>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import SendAttendanceSurvey from '@/components/SendAttendanceSurvey.vue'

const {
  mapMutations: newAttendanceFormMutations,
  mapActions: newAttendanceFormActions,
  mapGetters: newAttendanceFormGetters,
} = createNamespacedHelpers('newAttendanceForm')

export default {
  name: 'PtIgaFormNode',
  components: { SendAttendanceSurvey },
  async created() {
    const extraAnswer = this.extraAnswers['pt-iga']
    if (extraAnswer) {
      this.form = extraAnswer
      return
    }

    const surveyId = this.extraAnswers['survey']?.ptiga?.uuid
    if (surveyId) {
      const survey = await this.$api.getSurveyByUuid(surveyId)
      this.form.ptiga.value = survey.data['ptiga'].value
    }
  },
  methods: {
    ...newAttendanceFormMutations(['updateExtraAnswer']),
    ...newAttendanceFormActions(['getParameter', 'getExtraAnswer']),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        ptiga: {
          value: null,
        },
      },
    }
  },
  computed: {
    ...newAttendanceFormGetters(['parameters', 'extraAnswers']),
    ptigaOptions() {
      return [
        { text: 'Ausente (sem lesões)', value: 0 },
        { text: 'Pouquíssimas lesões', value: 1 },
        { text: 'Leve', value: 2 },
        { text: 'Moderada', value: 3 },
        { text: 'Grave', value: 4 },
      ]
    },
  },
  watch: {
    form: {
      handler(value) {
        this.updateExtraAnswer({ name: 'pt-iga', value })
      },
      deep: true,
    },
  },
}
</script>
<style scoped>
.reference {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
}
</style>
